/**
 * Copyright (C) Boost commerce
 * This file is part of commercial Boost commerce projects
 *
 * This file can not be copied and/or distributed without the express
 * permission of Boost commerce
 *
 * Created on Sat Jul 01 2023 00:16:39
 */
// @flow

import type { Action } from './store.type';

export const GET_CSAT_ADMIN_APP_DISPLAY_REQUEST = 'GET_CSAT_ADMIN_APP_DISPLAY_REQUEST';
type GET_CSAT_ADMIN_APP_DISPLAY_REQUEST_TYPE = 'GET_CSAT_ADMIN_APP_DISPLAY_REQUEST';
export const GET_CSAT_ADMIN_APP_DISPLAY_SUCCESS = 'GET_CSAT_ADMIN_APP_DISPLAY_SUCCESS';
type GET_CSAT_ADMIN_APP_DISPLAY_SUCCESS_TYPE = 'GET_CSAT_ADMIN_APP_DISPLAY_SUCCESS';
export const GET_CSAT_ADMIN_APP_DISPLAY_FAILURE = 'GET_CSAT_ADMIN_APP_DISPLAY_FAILURE';
type GET_CSAT_ADMIN_APP_DISPLAY_FAILURE_TYPE = 'GET_CSAT_ADMIN_APP_DISPLAY_FAILURE';

export const CLOSE_FEEDBACK_WIDGET_REQUEST = 'CLOSE_FEEDBACK_WIDGET_REQUEST';
type CLOSE_FEEDBACK_WIDGET_REQUEST_TYPE = 'CLOSE_FEEDBACK_WIDGET_REQUEST';
export const CLOSE_FEEDBACK_WIDGET_SUCCESS = 'CLOSE_FEEDBACK_WIDGET_SUCCESS';
type CLOSE_FEEDBACK_WIDGET_SUCCESS_TYPE = 'CLOSE_FEEDBACK_WIDGET_SUCCESS';
export const CLOSE_FEEDBACK_WIDGET_FAILURE = 'CLOSE_FEEDBACK_WIDGET_FAILURE';
type CLOSE_FEEDBACK_WIDGET_FAILURE_TYPE = 'CLOSE_FEEDBACK_WIDGET_FAILURE';

export const CREATE_CSAT_FEEDBACK_REQUEST = 'CREATE_CSAT_FEEDBACK_REQUEST';
type CREATE_CSAT_FEEDBACK_REQUEST_TYPE = 'CREATE_CSAT_FEEDBACK_REQUEST';
export const CREATE_CSAT_FEEDBACK_SUCCESS = 'CREATE_CSAT_FEEDBACK_SUCCESS';
type CREATE_CSAT_FEEDBACK_SUCCESS_TYPE = 'CREATE_CSAT_FEEDBACK_SUCCESS';
export const CREATE_CSAT_FEEDBACK_FAILURE = 'CREATE_CSAT_FEEDBACK_FAILURE';
type CREATE_CSAT_FEEDBACK_FAILURE_TYPE = 'CREATE_CSAT_FEEDBACK_FAILURE';

type CSATAdminAppDisplay = {
  isShow: boolean,
  isMultiple: boolean,
  metadata: Object
};

type CloseFeedbackWidgetRequestAction = Action<CLOSE_FEEDBACK_WIDGET_REQUEST_TYPE, any>;
type CloseFeedbackWidgetSuccessAction = Action<CLOSE_FEEDBACK_WIDGET_SUCCESS_TYPE, any>;
type CloseFeedbackWidgetFailureAction = Action<CLOSE_FEEDBACK_WIDGET_FAILURE_TYPE, any>;

type CreateCSATFeedbackRequestAction = Action<CREATE_CSAT_FEEDBACK_REQUEST_TYPE, any>;
type CreateCSATFeedbackSuccessAction = Action<CREATE_CSAT_FEEDBACK_SUCCESS_TYPE, any>;
type CreateCSATFeedbackFailureAction = Action<CREATE_CSAT_FEEDBACK_FAILURE_TYPE, any>;

type GetCSATAdminAppDisplayRequestAction = Action<GET_CSAT_ADMIN_APP_DISPLAY_REQUEST_TYPE, null>;
type GetCSATAdminAppDisplaySuccessAction = Action<
  GET_CSAT_ADMIN_APP_DISPLAY_SUCCESS_TYPE,
  CSATAdminAppDisplay
>;
type GetCSATAdminAppDisplayFailureAction = Action<
  GET_CSAT_ADMIN_APP_DISPLAY_FAILURE_TYPE,
  { error: any }
>;

export type CSATFeedbackAction =
  | GetCSATAdminAppDisplayRequestAction
  | GetCSATAdminAppDisplaySuccessAction
  | GetCSATAdminAppDisplayFailureAction
  | CloseFeedbackWidgetRequestAction
  | CloseFeedbackWidgetSuccessAction
  | CloseFeedbackWidgetFailureAction
  | CreateCSATFeedbackRequestAction
  | CreateCSATFeedbackSuccessAction
  | CreateCSATFeedbackFailureAction;

export type CSATFeedbackState = {
  loading: boolean,
  success: boolean,
  error: any,
  isShow: boolean,
  isMultiple: boolean,
  metadata: Object
};
